import { render, staticRenderFns } from "./ReceivingSnapshot.vue?vue&type=template&id=848e70ee"
import script from "./ReceivingSnapshot.vue?vue&type=script&lang=js"
export * from "./ReceivingSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('848e70ee')) {
      api.createRecord('848e70ee', component.options)
    } else {
      api.reload('848e70ee', component.options)
    }
    module.hot.accept("./ReceivingSnapshot.vue?vue&type=template&id=848e70ee", function () {
      api.rerender('848e70ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ReceivingSnapshot.vue"
export default component.exports